import { DocumentationTabTypes } from '../../../../types/enums/DocumentationTabTypes';

/**
 * NOTE: ALL OF THE COLUMNS IN THIS FILE ARE ALSO USED IN CSV FILE CREATION
 */

const defaultColumns = [
  {
    field: 'label',
    headerName: 'Label',
    showSortIcon: true,
    minWidth: '200px',
  },
  {
    field: 'name',
    headerName: 'API Name',
    showSortIcon: true,
  },
  {
    field: 'status',
    headerName: 'Status',
    showSortIcon: true,
  },
  {
    field: 'createdAt',
    headerName: 'Created date',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'createdBy',
    headerName: 'Created by',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedAt',
    headerName: 'Last modified',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedBy',
    headerName: 'Last modified by',
    showSortIcon: true,
    width: '200px',
  },
];

const sfAutomationsColumns = [
  {
    field: 'label',
    headerName: 'Label',
    showSortIcon: true,
    minWidth: '200px',
  },
  {
    field: 'name',
    headerName: 'API Name',
    showSortIcon: true,
  },
  {
    field: 'parentType',
    headerName: 'Type',
    showSortIcon: true,
  },
  {
    field: 'status',
    headerName: 'Status',
    showSortIcon: true,
  },
  {
    field: 'createdAt',
    headerName: 'Created date',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'createdBy',
    headerName: 'Created by',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedAt',
    headerName: 'Last modified',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedBy',
    headerName: 'Last modified by',
    showSortIcon: true,
    width: '200px',
  },
];

const fieldsTableColumns = [
  {
    field: 'label',
    headerName: 'Label',
    showSortIcon: true,
    minWidth: '200px',
  },
  {
    field: 'name',
    headerName: 'API Name',
    showSortIcon: true,
  },
  {
    field: 'description',
    headerName: 'Description',
  },
  {
    field: 'fieldType',
    headerName: 'Type',
    showSortIcon: true,
  },
  { field: 'usage', headerName: 'Utilization', showSortIcon: true },
  {
    field: 'createdAt',
    headerName: 'Created date',
    showSortIcon: true,
    width: '150px',
  },
  {
    field: 'createdBy',
    headerName: 'Created by',
    showSortIcon: true,
    width: '150px',
  },
  {
    field: 'updatedAt',
    headerName: 'Last modified',
    showSortIcon: true,
    width: '150px',
  },
  {
    field: 'updatedBy',
    headerName: 'Last modified by',
    showSortIcon: true,
    width: '150px',
  },
];

const sweepAutomationsColumns = [
  {
    field: 'label',
    headerName: 'Name',
    showSortIcon: true,
  },
  {
    field: 'trigger',
    headerName: 'Trigger',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'actionsToRender',
    headerName: 'Actions',
    width: '200px',
  },
  {
    field: 'status',
    headerName: 'Status',
    showSortIcon: true,
    width: '100px',
    minWidth: '100px',
  },
  {
    field: 'createdAt',
    headerName: 'Created date',
    showSortIcon: true,
    width: '150px',
  },
  {
    field: 'createdBy',
    headerName: 'Created by',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedAt',
    headerName: 'Last modified',
    showSortIcon: true,
    minWidth: '150px',
  },
  {
    field: 'updatedBy',
    headerName: 'Last modified by',
    showSortIcon: true,
    width: '200px',
  },
];

const sweepAssignmentsColumns = [
  {
    field: 'label',
    headerName: 'Name',
    showSortIcon: true,
  },
  {
    field: 'trigger',
    headerName: 'Trigger',
    showSortIcon: true,
  },
  {
    field: 'actionsToRender',
    headerName: 'Rules',
  },
  {
    field: 'status',
    headerName: 'Status',
    showSortIcon: true,
  },
  {
    field: 'createdAt',
    headerName: 'Created date',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'createdBy',
    headerName: 'Created by',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedAt',
    headerName: 'Last modified',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedBy',
    headerName: 'Last modified by',
    showSortIcon: true,
    width: '200px',
  },
];

const sweepDedupeAndMatchingColumns = [
  {
    field: 'label',
    headerName: 'Name',
    showSortIcon: true,
  },
  {
    field: 'actionsToRender',
    headerName: 'Action',
  },
  {
    field: 'status',
    headerName: 'Status',
    showSortIcon: true,
  },
  {
    field: 'createdAt',
    headerName: 'Created date',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'createdBy',
    headerName: 'Created by',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedAt',
    headerName: 'Last modified',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedBy',
    headerName: 'Last modified by',
    showSortIcon: true,
  },
];

const layoutsColumns = [
  {
    field: 'label',
    headerName: 'Name',
    showSortIcon: true,
    minWidth: '300px',
  },
  {
    field: 'createdAt',
    headerName: 'Created date',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'createdBy',
    headerName: 'Created by',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedAt',
    headerName: 'Last modified',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedBy',
    headerName: 'Last modified by',
    showSortIcon: true,
    width: '200px',
  },
];

const othersColumns = [
  {
    field: 'label',
    headerName: 'Name',
    showSortIcon: true,
    minWidth: '300px',
  },
  {
    field: 'name',
    headerName: 'API Name',
    showSortIcon: true,
    minWidth: '300px',
  },
  {
    field: 'namespace',
    headerName: 'Namespace',
    showSortIcon: true,
    minWidth: '300px',
  },
  {
    field: 'status',
    headerName: 'Status',
    showSortIcon: true,
  },
  {
    field: 'createdAt',
    headerName: 'Created date',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'createdBy',
    headerName: 'Created by',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedAt',
    headerName: 'Last modified',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedBy',
    headerName: 'Last modified by',
    showSortIcon: true,
    width: '200px',
  },
];

const recordTypesColumns = [
  {
    field: 'label',
    headerName: 'Label',
    showSortIcon: true,
  },
  {
    field: 'name',
    headerName: 'API Name',
    showSortIcon: true,
  },
  {
    field: 'description',
    headerName: 'Description',
  },
  {
    field: 'status',
    headerName: 'Status',
    showSortIcon: true,
  },
  {
    field: 'createdAt',
    headerName: 'Created date',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'createdBy',
    headerName: 'Created by',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedAt',
    headerName: 'Last modified',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedBy',
    headerName: 'Last modified by',
    showSortIcon: true,
    width: '200px',
  },
];

const apexColumnsWithType = [
  {
    field: 'label',
    headerName: 'Name',
    showSortIcon: true,
  },
  {
    field: 'parentType',
    headerName: 'Type',
    showSortIcon: true,
  },
  {
    field: 'status',
    headerName: 'Status',
    showSortIcon: true,
  },
  {
    field: 'createdAt',
    headerName: 'Created date',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'createdBy',
    headerName: 'Created by',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedAt',
    headerName: 'Last modified',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedBy',
    headerName: 'Last modified by',
    showSortIcon: true,
    width: '200px',
  },
];

const validationRulesColumns = [
  {
    field: 'label',
    headerName: 'Label',
    showSortIcon: true,
    minWidth: '200px',
  },
  {
    field: 'status',
    headerName: 'Status',
    showSortIcon: true,
  },
  {
    field: 'description',
    headerName: 'Description',
  },
  {
    field: 'errorMessage',
    headerName: 'Error message',
    showSortIcon: true,
  },
  {
    field: 'createdAt',
    headerName: 'Created date',
    showSortIcon: true,
    width: '150px',
  },
  {
    field: 'createdBy',
    headerName: 'Created by',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedAt',
    headerName: 'Last modified',
    showSortIcon: true,
    width: '150px',
  },
  {
    field: 'updatedBy',
    headerName: 'Last modified by',
    showSortIcon: true,
    width: '200px',
  },
];

const relatedObjectsColumns = [
  {
    field: 'label',
    headerName: 'Label',
    showSortIcon: true,
  },
  {
    field: 'name',
    headerName: 'API Name',
    showSortIcon: true,
  },
  {
    field: 'parentType',
    headerName: 'Type',
    showSortIcon: true,
  },
  {
    field: 'referencedObjects',
    headerName: 'Related objects',
    showSortIcon: true,
    width: '150px',
  },
  {
    field: 'status',
    headerName: 'Status',
    showSortIcon: true,
  },
  {
    field: 'description',
    headerName: 'Description',
  },
  {
    field: 'createdAt',
    headerName: 'Created date',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'createdBy',
    headerName: 'Created by',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedAt',
    headerName: 'Last modified',
    showSortIcon: true,
    width: '200px',
  },
  {
    field: 'updatedBy',
    headerName: 'Last modified by',
    showSortIcon: true,
    width: '200px',
  },
];

export const getColumns = (documentationTabType: DocumentationTabTypes) => {
  switch (documentationTabType) {
    case DocumentationTabTypes.FIELDS:
      return fieldsTableColumns;

    case DocumentationTabTypes.SF_AUTOMATIONS:
      return sfAutomationsColumns;

    case DocumentationTabTypes.MATCHING_DEDUPE:
      return sweepDedupeAndMatchingColumns;

    case DocumentationTabTypes.LAYOUTS:
      return layoutsColumns;

    case DocumentationTabTypes.OTHER:
      return othersColumns;

    case DocumentationTabTypes.RECORD_TYPES:
      return recordTypesColumns;

    case DocumentationTabTypes.SWEEP_AUTOMATIONS:
    case DocumentationTabTypes.PLAYBOOK_ALERTS:
      return sweepAutomationsColumns;

    case DocumentationTabTypes.SCHEDULED_ASSIGNMENTS:
    case DocumentationTabTypes.ASSIGNMENTS:
      return sweepAssignmentsColumns;

    case DocumentationTabTypes.APEX:
      return apexColumnsWithType;

    case DocumentationTabTypes.VALIDATION_RULES:
      return validationRulesColumns;

    case DocumentationTabTypes.RELATED_OBJECTS:
      return relatedObjectsColumns;

    default:
      return defaultColumns;
  }
};
